import type { ICollectionType, IField, ISchema } from 'contracts/interfaces';
import React from 'react';
import type { SchemaContextHelper } from './SchemaContextHelper';

export enum SchemaActionTypes {
  INIT_SCHEMA = 'INIT_SCHEMA',
  ADD_FIELD = 'ADD_FIELD',
  ADD_NEW_FIELD = 'ADD_NEW_FIELD',
  REMOVE_FIELD = 'REMOVE_FIELD',
  SWITCH_ORDER = 'SWITCH_ORDER',
  ADD_CHILD = 'ADD_CHILD',
  SELECT_FIELD = 'SELECT_FIELD',
  UPDATE_SETTING = 'UPDATE_SETTING',
  UPDATE_NAME = 'UPDATE_NAME',
  UPDATE_TYPE = 'UPDATE_TYPE'
}

export interface IAddNewFieldPayload {
  fieldPath: string[];
}
export interface IFieldPayload {
  path: string[];
  field: string;
  val: ICollectionType | IField;
}
export interface IFieldPath {
  path: string[] | null;
}

export interface ISourceTargetPath {
  sPath: string[];
  tPath: string[];
}

export interface ICollectionPayload {
  field: string;
  collection: ICollectionType;
}

export interface IAddCollection {
  type: SchemaActionTypes.ADD_FIELD;
  payload: IFieldPayload;
}

export interface IAddNewField {
  type: SchemaActionTypes.ADD_NEW_FIELD;
  payload: IAddNewFieldPayload;
}

export interface ISwitchOrder {
  type: SchemaActionTypes.SWITCH_ORDER;
  payload: ISourceTargetPath;
}

export interface IRemoveField {
  type: SchemaActionTypes.REMOVE_FIELD;
  payload: IFieldPath;
}

export interface ISourceModel extends IFieldPath {
  uuid: string;
  schema: ISchema;
  name: string;
  link?: {
    modelUuid: string;
    schema?: ISchema;
  } & IFieldPath;
}

export interface ISelectField {
  type: SchemaActionTypes.SELECT_FIELD;
  payload: { source?: ISourceModel } & IFieldPath;
}

export interface IAddChild {
  type: SchemaActionTypes.ADD_CHILD;
  payload: ISourceTargetPath;
}

export interface IInitSchema {
  type: SchemaActionTypes.INIT_SCHEMA;
  payload: {
    name: string;
    schema: ISchema;
    uuid: string;
    locked?: boolean;
  };
}

export interface ITogglePropertyPayload {
  set: boolean;
  property: string;
  fieldPath: string[];
  initValue: any;
}

export interface IUpdateDefaultPayload {
  path: string[];
  property: string;
  value: any;
}

export interface IUpdateSettingPayload {
  path: string[];
  property: string[];
  value: any;
}

export interface IUpdateSetting {
  type: SchemaActionTypes.UPDATE_SETTING;
  payload: IUpdateSettingPayload;
}

export interface IUpdateNamePayload {
  path: string[];
  fieldName: string;
}

export interface IUpdateName {
  type: SchemaActionTypes.UPDATE_NAME;
  payload: IUpdateNamePayload;
}

export interface IUpdateTypePayload {
  fieldPath: string[];
  type: string;
}

export interface IUpdateType {
  type: SchemaActionTypes.UPDATE_TYPE;
  payload: IUpdateTypePayload;
}

export type SchemaActions =
  | IAddCollection
  | IAddNewField
  | IRemoveField
  | ISelectField
  | IAddChild
  | IInitSchema
  | IUpdateSetting
  | IUpdateName
  | IUpdateType
  | ISwitchOrder;

export interface ISchemaState {
  schema: ISchema;
  name: string;
  locked: boolean;
  uuid?: string;
  selectedField: string[] | null;
  selectedSchema: null | ISourceModel | undefined;
}
export interface SchemaContextInterface {
  state: ISchemaState;
  dispatch: (SchemaAction: SchemaActions) => void;
  helper: SchemaContextHelper;
}
export const SchemaContext = React.createContext<SchemaContextInterface | null>(null);
